import checkAjaxError from '@ott/helper-check-ajax-error';
import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import makeCustomerCareInfo from '../../helpers/customerCare';
import { AuthError } from '../../types';
import { getBasicUserInfo } from '../getBasicUserInfo';
import { Payload, ResponseSuccess, ThunkResult } from './types';

export const getOAuthInfo = createAsyncThunk<ThunkResult, Payload, { rejectValue: AuthError }>(
  'auth/getOAuthUrl',
  async ({ oAuthModal, provider, code, token, reqHost = '' }, { dispatch, rejectWithValue }) => {
    const isCallbackFlow = !!code || !!token;

    const getOAuthRequestUrl = `/_auth/authenticate/oauth-url`;
    const customerInfo = makeCustomerCareInfo({
      getOAuthRequestUrl,
      step: 'get-oauth-url',
    });

    try {
      const res = await superagent
        .get(getOAuthRequestUrl)
        .query({
          provider,
        })
        .withCredentials();

      if (isCallbackFlow) {
        const {
          body: { result, error },
        } = await superagent
          .get('/_auth/authenticate/oauth-callback')
          .query({
            provider,
            oauth_token: token,
            code,
          })
          .withCredentials();

        if (result === 'OK') {
          dispatch(getBasicUserInfo({ reqHost }));
        }

        if (error) {
          return rejectWithValue({
            data: { customerInfo, error },
            status: res.status,
          });
        }
      }

      const responseBody = res.body as ResponseSuccess;

      if (responseBody && responseBody?.result) {
        return { ...responseBody.result, oAuthModal } as ThunkResult;
      }

      return rejectWithValue({
        data: { customerInfo, error: responseBody?.error as string },
        status: res.status,
      });
    } catch (e) {
      return rejectWithValue({ data: checkAjaxError(e, customerInfo) });
    }
  }
);
